"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDailyColumns = void 0;
require("../types");
const getDailyColumns = () => {
    const hours = [12, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11];
    return hours.map((h) => ({
        title: h.toString(),
    }));
};
exports.getDailyColumns = getDailyColumns;
//# sourceMappingURL=getDailyColumns.js.map